module.exports = __webpack_public_path__ + "img/flask-conical.1a50c78b.svg";